import { LocalizedText } from "@/i18n/LocalizedText";
import * as React from "react";
import { ArrowDown } from "lucide-react";
import { Button } from "@/components/ui/button";
import { cn } from "@/lib/utils";

function Conversation({ className, ...props }: React.ComponentProps<"div">) {
  return (
    <div
      data-slot="conversation"
      className={cn(
        "relative flex min-h-0 flex-1 flex-col overflow-hidden",
        className,
      )}
      {...props}
    />
  );
}

function ConversationContent({
  className,
  ...props
}: React.ComponentProps<"div">) {
  return (
    <div
      data-slot="conversation-content"
      className={cn("flex-1 space-y-4 overflow-y-auto p-4", className)}
      {...props}
    />
  );
}

function ConversationScrollButton({
  className,
  ...props
}: React.ComponentProps<typeof Button>) {
  return (
    <Button
      type="button"
      size="icon"
      variant="outline"
      data-slot="conversation-scroll-button"
      className={cn(
        "absolute bottom-3 left-1/2 h-8 w-8 -translate-x-1/2 rounded-full bg-white shadow-sm",
        className,
      )}
      {...props}
    >
      <ArrowDown className="h-4 w-4" />
      <span className="sr-only">
        <LocalizedText id="legacy.scroll.to.latest.message.ry86xv" />
      </span>
    </Button>
  );
}

export { Conversation, ConversationContent, ConversationScrollButton };
